import { createSelector } from '@reduxjs/toolkit'
import { IBoardMember } from 'shared/models/Board'
import { RootState } from 'shared/store/store'
import { getUser } from '../user/selectors'

export const getBoard = (state: RootState) => state.board

export const getBoardMembers = (state: RootState) => state.board.data?.members

// getUser wrapped in an arrow to avoid reading its binding at module-eval:
// board and user/selectors are part of a circular import, so a direct
// reference can hit getUser's TDZ depending on load order.
export const getBoardFunctionForActiveUser = createSelector(
  [(state: RootState) => getUser(state), getBoard],
  (user, board) => {
    const nameId = user.data?.id

    const role = board.data?.members?.find(
      (x: IBoardMember) => x.person.id === nameId
    )
    return role?.memberFunction || ''
  }
)

export const getBoardSizeBasedOnMemberFunction = (state: RootState) => {
  const membersWithQueriedFunctions = state.board.data?.members?.filter(
    (member) => member.boardMember || member.chairman || member.deputy
  )

  return membersWithQueriedFunctions?.length || 0
}
